import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { STC_V2 } from 'src/app/shared/consts/api-version.config';
import { PaymentDto, PaymentDtoV2 } from 'src/app/shared/models/payment/payment-dto.model';
import { environment as env } from 'src/environments/environment';

const PAYMENT_CONFIRMATION_ENDPOINT = '/payment-confirmation';

@Injectable({
  providedIn: 'root'
})
export class PaymentConfirmationService {
  constructor(private httpClient: HttpClient) {}

  headers = new HttpHeaders({
    'Content-Type': STC_V2,
    Accept: STC_V2
  });

  getPaymentSummary$(billId: string): Observable<PaymentDtoV2> {
    return this.httpClient.get<PaymentDtoV2>(
      `${env.BACKEND_API.BASE}${env.BACKEND_API.PAYMENTS}/${billId}`, {headers: this.headers}
    );
  }

  getManualPaymentSummary$(applicationId: string): Observable<PaymentDtoV2> {
    return this.httpClient.get<PaymentDtoV2>(
      `${env.BACKEND_API.BASE}${env.BACKEND_API.PAPER_FORM}/${applicationId}${env.BACKEND_API.MANUAL_PAYMENT_SUMMARY}`
    );
  }
}
